// Angular
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Helpers
import { Base64 } from '../shared/lib/helpers/utils';

@Component({
    selector: 'product-info-print',
    templateUrl: './product-info-print.component.html',
})
export class ProductInfoPrintComponent implements OnInit {
    nombre: string = Base64.decode(this.activatedRoute.snapshot.paramMap.get('nombre')).replace('--', '/');
    marca: string = this.activatedRoute.snapshot.paramMap.get('marca').replace('--', '/');
    consumo: string = this.activatedRoute.snapshot.paramMap.get('consumo').replace('--', '/');
    agarre: string = this.activatedRoute.snapshot.paramMap.get('agarre').replace('--', '/');
    ruido: string = this.activatedRoute.snapshot.paramMap.get('ruido').replace('--', '/');
    etiquetado2: string = this.activatedRoute.snapshot.paramMap.get('etiquetado2').replace('--', '/');

    onda: string = '';
    hielo: string = '';
    nieve: string = '';
    ancho: string = '';
    perfil: string = '';
    llanta: string = '';
    provider: string = '';
    qr: string = '';
    carga: string = '';
    velocidad: string = '';

    constructor(private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.snapshot.paramMap.get('onda')) {
            this.onda = this.activatedRoute.snapshot.paramMap.get('onda').replace('--', '/');
            this.hielo = this.activatedRoute.snapshot.paramMap.get('hielo').replace('--', '/');
            this.nieve = this.activatedRoute.snapshot.paramMap.get('nieve').replace('--', '/');

            this.ancho = this.activatedRoute.snapshot.paramMap.get('ancho').replace('--', '/');
            this.perfil = this.activatedRoute.snapshot.paramMap.get('perfil').replace('--', '/');
            this.llanta = this.activatedRoute.snapshot.paramMap.get('llanta').replace('--', '/');
            this.provider = this.activatedRoute.snapshot.paramMap.get('provider').replace('--', '/');
            this.qr = this.activatedRoute.snapshot.paramMap.get('qr').replace('--', '/');
            this.carga = this.activatedRoute.snapshot.paramMap.get('carga').replace('--', '/');
            this.velocidad = this.activatedRoute.snapshot.paramMap.get('velocidad').replace('--', '/');
        }
    }

    ngOnInit(): void {
        if (this.qr !== '' && this.qr !== null) {
            this.qr = Base64.decode(this.qr);
        } else {
            this.qr = '';
        }
        // Print
        window.print();
    }

    showOldLabel(onda: string): boolean {
        return onda === null || onda === '' || onda === '0' || onda === '1' || onda === '2' || onda === '3';
    }
}
